import { SET_SESSION_TIMEOUT_CONFIG, SET_SESSION_TIMEOUT_REMAINING, SET_SESSION_TIMEOUT_WARNING } from './actionTypes';
/**
 * 部屋のタイムアウト設定を保存する。
 *
 * @param {ISessionTimeoutConfig} config - 取得した設定。取れなかったときは enabled:false。
 * @returns {Object}
 */
export function setSessionTimeoutConfig(config) {
    return {
        type: SET_SESSION_TIMEOUT_CONFIG,
        config
    };
}
/**
 * 残り時間を更新する。
 *
 * @param {number} idleLeftMs - 無操作タイマーの残り(ms)。
 * @param {number} maxLeftMs - 上限タイマーの残り(ms)。
 * @returns {Object}
 */
export function setSessionTimeoutRemaining(idleLeftMs, maxLeftMs) {
    return {
        type: SET_SESSION_TIMEOUT_REMAINING,
        idleLeftMs,
        maxLeftMs
    };
}
/**
 * 予告ダイアログの表示を切り替える。
 *
 * @param {'idle'|'max'|null} reason - 何のタイマーで出すか。null で閉じる。
 * @returns {Object}
 */
export function setSessionTimeoutWarning(reason) {
    return {
        type: SET_SESSION_TIMEOUT_WARNING,
        reason
    };
}
